import styles from "exports.module.scss";

import { getDimensionFromCSSVar } from "seneca-common/utils/functions";

const WIDTH_BELOW_WHICH_SIDEBAR_OVERLAY_USED =
  getDimensionFromCSSVar(styles.sessionmobilebreakpoint) +
  getDimensionFromCSSVar(styles.sidebarwidth);

export const sidebarWillOverlayClassroomWhenOpen = (): boolean =>
  window.innerWidth < WIDTH_BELOW_WHICH_SIDEBAR_OVERLAY_USED;
